import { GET_RECONCILIATION, GET_RECONCILIATION_MISMATCHES, GET_RECONCILIATION_FILES_LIST, RECONCILE } from "../api/constApi";
import { apiInstance } from "./axiosApi";
import { metriwsBaseUrl } from "../api/baseUrl";

export const getReconciliation = (payload) => {
  return apiInstance.post(GET_RECONCILIATION, payload);
};

export const getReconciliationMismatches = (payload) => {
  return apiInstance.post(GET_RECONCILIATION_MISMATCHES, payload);
};

export const getReconciliationFilesList = (payload) => {
  return apiInstance.post(GET_RECONCILIATION_FILES_LIST, payload);
};

export const postReconcile = (payload) => {
  return apiInstance.post(RECONCILE, payload, {
    baseURL: metriwsBaseUrl,
  });
};


